<script lang="ts">
  import { AUTO_FORWARDING_INSTRUCTIONS_URL } from "../../constants/url";
  import TextNew from "../TextNew.svelte";
  import ModalInstructionsStepCard from "../modals/ModalInstructionsStepCard.svelte";
  import InvoiceUploadStepSupplierDetails from "./InvoiceUploadStepSupplierDetails.svelte";
  import type { TransformedSupplier } from "../../api/suppliers";
  import WhatsappContactCard from "../modals/WhatsappContactCard.svelte";

  export let suppliers: TransformedSupplier[] | undefined;
</script>

<ModalInstructionsStepCard step={1} title="use one email for invoices">
  <TextNew size="s" --rk-text-color="var(--rk-text-low)" --line-height="24px">
    we recommend creating a new email address where you'll collect invoices from all of your
    suppliers
  </TextNew>
</ModalInstructionsStepCard>

<ModalInstructionsStepCard step={2} title="call suppliers and ask to send invoices to that address">
  {#if suppliers}
    <div class="supplier-list">
      {#each suppliers as supplier (supplier.id)}
        <InvoiceUploadStepSupplierDetails
          name={supplier.name}
          phoneNumber={supplier.phone_number}
        />
      {/each}
    </div>
  {/if}
</ModalInstructionsStepCard>

<ModalInstructionsStepCard step={3} title="set up auto forwarding to invoices@rekki.com">
  <TextNew size="s" --rk-text-color="var(--rk-text-low)" --line-height="24px">
    now that you have invoices in your inbox, forward them to REKKI using our
    <a href={AUTO_FORWARDING_INSTRUCTIONS_URL} target="_blank" class="link">guide</a>
  </TextNew>
</ModalInstructionsStepCard>

<WhatsappContactCard description="reach out on Whatsapp – we are happy to help" />

<style>
  .supplier-list {
    padding-top: 11px;
  }

  .link {
    color: var(--rk-primary-accent);
    text-decoration: none;
  }

  .link:hover,
  .link:focus-visible {
    text-decoration: underline;
  }
</style>
